import { render } from "./EditPackages.vue?vue&type=template&id=41ed2fd9"
import script from "./EditPackages.vue?vue&type=script&lang=js"
export * from "./EditPackages.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/packing_house/production/uniq_final_packing_list/edit_packages.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fpacking_house%2Fproduction%2Funiq_final_packing_list%2FEditPackages.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/package.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fpacking_house%2Fproduction%2Funiq_final_packing_list%2FEditPackages.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__